import { Pipe, PipeTransform, inject } from "@angular/core";
import { LookerStudioService } from "../services/looker-studio.service";

@Pipe({
  standalone: true,
  name: "prettifyAttribute",
})
export class PrettifyAttributePipe implements PipeTransform {
  private looker = inject(LookerStudioService);


  transform(before: string): string {
    return this.looker.prettifyAttribute(before);
  }
}
